<template>
  <div>
    <div v-if="tournament && tournament.matches && tournament.matches.length>0">
      <md-list>
        <md-list-item md-expand>
          <md-icon>filter_list</md-icon>
          <span class="md-list-item-text">Options</span>

          <md-list slot="md-expand" class="flex-container">
            <md-list-item class="md-inset flex-item">
              <md-switch v-model="showCompleted">Completed matches</md-switch>
            </md-list-item>
            <md-list-item class="md-inset flex-item">
              <md-switch v-model="showInProgress">In-progress matches</md-switch>
            </md-list-item>
            <md-list-item class="md-inset flex-item">
              <md-switch v-model="showReady">Ready-to-start matches</md-switch>
            </md-list-item>
            <md-list-item class="md-inset flex-item">
              <md-switch v-model="showPending">Pending matches</md-switch>
            </md-list-item>
          </md-list>
        </md-list-item>
      </md-list>

      <!-- The match listings -->
      <div class="flex-container">
        <MatchList
          v-if="showCompleted"
          title="Completed"
          :matches="completedMatches"
          :tournament="tournament"
          class="flex-item"
        />
        <MatchList
          v-if="showInProgress"
          title="In-progress"
          :matches="inProgressMatches"
          :tournament="tournament"
          class="flex-item"
        />
        <MatchList
          v-if="showReady"
          title="Ready-to-start"
          :matches="readyMatches"
          :tournament="tournament"
          class="flex-item"
        />
        <MatchList
          v-if="showPending"
          title="Pending"
          :matches="pendingMatches"
          :tournament="tournament"
          class="flex-item"
        />
      </div>
    </div>
    <div v-else>
      <md-empty-state
        md-icon="remove_circle"
        md-label="There are currently no matches for this tournament"
      ></md-empty-state>
    </div>
  </div>
</template>

<script>
import { relativeTime, MatchTools } from "@/js/helper";
import MatchList from "./matchList.vue";

export default {
  name: "TournamentMatches",
  components: {
    MatchList
  },
  props: { tournament: Object },
  computed: {
    showCompleted: {
      get() {
        return this.$store.state.showCompleted;
      },
      set(value) {
        this.$store.commit("setShowCompleted", value);
      }
    },
    showInProgress: {
      get() {
        return this.$store.state.showInProgress;
      },
      set(value) {
        this.$store.commit("setShowInProgress", value);
      }
    },
    showReady: {
      get() {
        return this.$store.state.showReady;
      },
      set(value) {
        this.$store.commit("setShowReady", value);
      }
    },
    showPending: {
      get() {
        return this.$store.state.showPending;
      },
      set(value) {
        this.$store.commit("setShowPending", value);
      }
    },
    completedMatches: {
      get() {
        return this.tournament.matches.filter(x => this.isCompleted(x));
      }
    },

    inProgressMatches: {
      get() {
        return this.tournament.matches.filter(x => this.isInProgress(x));
      }
    },
    readyMatches: {
      get() {
        return this.tournament.matches.filter(x =>
          this.isReady(this.tournament, x)
        );
      }
    },
    pendingMatches: {
      get() {
        return this.tournament.matches.filter(x =>
          this.isPending(this.tournament, x)
        );
      }
    }
  },
  methods: {
    relativeTime: relativeTime,
    isReady: MatchTools.isReady,
    isCompleted: MatchTools.isCompleted,
    isInProgress: MatchTools.isInProgress,
    isPending: MatchTools.isPending
  }
};
</script>

<style lang="scss" scoped>
.flex-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.flex-item {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
}
</style>


// WEBPACK FOOTER //
// tournamentMatches.vue?6d990a0c